/**
 * @generated SignedSource<<0c2ad0601128319e084fe547d3d8d145>>
 * @relayHash ae335ccbbdafd28c0b60d5176236e1a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issuesModal_designIssueQuery$variables = {
  cloudAri: string;
  designAris: ReadonlyArray<string>;
  versionId: string;
};
export type issuesModal_designIssueQuery$data = {
  readonly devOps: {
    readonly designEntityDetails: ReadonlyArray<{
      readonly displayName: string;
      readonly provider: {
        readonly logoUrl: AGG$URL;
      };
      readonly url: AGG$URL;
      readonly " $fragmentSpreads": FragmentRefs<"body_versionIssueAssociatedDesigns_IssuesModalBody">;
    } | null | undefined>;
  };
};
export type issuesModal_designIssueQuery = {
  response: issuesModal_designIssueQuery$data;
  variables: issuesModal_designIssueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "designAris"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "designAris"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "cloudAri"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "logoUrl"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issuesModal_designIssueQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOps",
          "kind": "LinkedField",
          "name": "devOps",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "DevOpsDesign",
                "kind": "LinkedField",
                "name": "designEntityDetails",
                "plural": true,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v4/*: any*/),
                    "action": "THROW",
                    "path": "devOps.designEntityDetails.url"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v5/*: any*/),
                    "action": "THROW",
                    "path": "devOps.designEntityDetails.displayName"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "args": (v6/*: any*/),
                      "kind": "LinkedField",
                      "name": "provider",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v7/*: any*/),
                          "action": "THROW",
                          "path": "devOps.designEntityDetails.provider.logoUrl"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "devOps.designEntityDetails.provider"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "body_versionIssueAssociatedDesigns_IssuesModalBody"
                  }
                ]
              },
              "action": "THROW",
              "path": "devOps.designEntityDetails"
            }
          ]
        },
        "action": "THROW",
        "path": "devOps"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "issuesModal_designIssueQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "DevOpsDesign",
            "kind": "LinkedField",
            "name": "designEntityDetails",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": (v6/*: any*/),
                "kind": "LinkedField",
                "name": "provider",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  }
                ],
                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                "kind": "LinkedField",
                "name": "associatedIssues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "versionId",
                                    "variableName": "versionId"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "hasRelationshipToVersion"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "idsOrAliases",
                                    "value": [
                                      "issuetype",
                                      "summary"
                                    ]
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "ignoreMissingFields",
                                    "value": true
                                  }
                                ],
                                "kind": "LinkedField",
                                "name": "fieldsByIdOrAlias",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "name"
                                          },
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "xsmall"
                                              }
                                            ]
                                          },
                                          (v9/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraIssueTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "text"
                                      }
                                    ],
                                    "type": "JiraSingleLineTextField"
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ],
                "storageKey": "associatedIssues(first:100)"
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf",
    "metadata": {},
    "name": "issuesModal_designIssueQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7de65187f74a740f22e361ae3bf58899";

export default node;
